import { HotelBedData } from '../shared/HotelBedData';
import { momentWrapper } from './campursari';
import { KEY_DEFAULT_SEARCH_DEST_CODE } from 'src/core/Const';
import { getAjaxhelper } from './CoreAjaxHelper';
interface SendReqAvailableResult {
    responKey: string;
    rekKey?: string;
    statusCode: string;
}
export async function sendHotelAvailibilityRequest(parameter: { filter: HotelBedData.SearchFilter, app: firebase.app.App }): Promise<SendReqAvailableResult> {
    //
    let reqFilter = parameter.filter;
    if (!reqFilter) {
        reqFilter = {
            stay: {
                checkIn: momentWrapper().add(1, 'days'), // moment(),
                checkOut: momentWrapper().add(3, 'days'), // moment().add(1 , 'days')
            },
            occupancies: [{
                rooms: 1,
                adults: 2,
                children: 0
            }],
            destination: {
                code: window[KEY_DEFAULT_SEARCH_DEST_CODE]
            }

        };
    }
    let dt1 = reqFilter!.stay!.checkIn;
    let dt2 = reqFilter!.stay!.checkOut;

    if (reqFilter.destination!.id) {
        delete reqFilter.destination!.id;
    }

    if (!reqFilter.destination!.zone || reqFilter.destination!.zone === 0) {
        delete reqFilter.destination!.zone;
    }

    if (typeof dt1 === 'string') {
        dt1 = momentWrapper(dt1);
    }
    if (typeof dt2 === 'string') {
        dt2 = momentWrapper(dt2);
    }

    reqFilter!.stay!.checkIn = dt1.format('YYYY-MM-DD');
    reqFilter!.stay!.checkOut = dt2.format('YYYY-MM-DD');

    reqFilter.boards = {
        included: true,
        board: ["RO", "BB"]
    };

    let filter: any = !reqFilter ? {} : reqFilter;

    if (filter && filter.hotels && filter.hotels.hotel && filter.hotels.hotel.length === 0) {
        filter.hotels.hotel = [];
    }  
    
    return getAjaxhelper().post(`/dynamics/hb-api/hotels`, {
        filter: filter
    });   
  /*
    let forceTriggerBatchByTask = (taskId: string, app: firebase.app.App) => {
        app.functions('asia-northeast1').httpsCallable('reqAvailableBatchForceTriggerHttpCall')({
            taskId: taskId
        }).then( (x: any ) => {
            console.log(`Force trigger batch ${taskId}. `, x);
        }).catch(exc => {
            console.error('Force trigger error:', exc);
        });
    };

    const d1: any = await parameter.app.functions('asia-northeast1').httpsCallable('reqAvailableHttpCall')({
        filter: filter
    });
    console.log('Call result: ', d1);
    const d: any = d1.data ? d1.data : {};
    if (d.batchTaskIds && d.batchTaskIds.length > 0) {
        console.log('Trigger total batch task: ', d.batchTaskIds.length);
        for (const btchI of d.batchTaskIds) {
            forceTriggerBatchByTask(btchI, parameter.app);
        }
    } else {
        console.log(`Task tidak di trigger paksa. batch size = 0 `);
    }
    
    let ret: SendReqAvailableResult = {
        responKey: d.reqKey,
        statusCode: 'REQUESTING'
    };
    return ret; 

    /*
    timer.stop();
    const docPath: string = d.checkPath;
    if (!docPath || typeof docPath !== 'string' || docPath.length === 0) {
        console.error(`Request filter gagal,pada data checkPath tidak terisi`);
    } else {
        if (this.monitorPanel) {
            this.monitorPanel.addWatchedPath(docPath, timer.currentTime);
        } else {
            alert('Ref ke monitor kosong. silakan cek manual kepath: ' + docPath);
        }
    }
    */

}


// WEBPACK FOOTER //
// ./src/utils/req-available-helper.ts